<div class="p-4 flex-col flex gap-4">
    <!-- Header -->
    <div class="flex flex-col gap-1">
        <div class="flex justify-between items-center">
            <h3 class="flex items-center gap-2 text-slate-800 m-0">
                <i class="pi pi-exclamation-triangle text-red-500"></i> 各系統告警統計
            </h3>
            <span class="bg-red-400 text-white text-xs px-2 py-1 rounded-md mb-0 shadow-sm font-bold">{{ statsData()?.totalUnclosedCount || 0 }} 筆</span>
        </div>
        <div class="text-xs text-slate-500 flex items-center gap-1 pl-6">
            <i class="pi pi-clock"></i>
            採樣時間 : {{ statsData()?.sampleTime | date:'yyyy-MM-dd HH:mm:ss' }}
        </div>
    </div>

    <!-- Grid -->
    <div class="grid grid-cols-4 gap-2">
        @for (item of mappedStats(); track item.systemName) {
        <div class="bg-white rounded-lg py-2 px-1 flex flex-col items-center justify-center text-center shadow-sm border border-slate-200">
            <span class="font-bold text-lg leading-none mb-1.5" [ngClass]="item.unclosedCount > 0 ? 'text-red-500' : 'text-slate-400'">{{ item.unclosedCount }}</span>
            <i class="ci text-slate-400 text-sm mb-1" [ngClass]="item.icon"></i>
            <span class="text-[10px] font-bold" [ngClass]="item.unclosedCount > 0 ? 'text-slate-600' : 'text-slate-400'">{{ item.percentage }}%</span>
        </div>
        }
    </div>
</div>